import apiService from '../../../services/api'
import { openExternalPaymentLink } from '../utils/openExternalPaymentLink'

export const fetchBynConfig = async () => {
  const response = await apiService.makeRequest('/api/byn1/')
  if (!response.byn) throw new Error('Invalid response format: byn config not found')
  return { ...response.byn, promo: response.promo || null }
}

export const fetchBynPackages = async () => {
  const response = await apiService.makeRequest('/api/topup/')
  if (!Array.isArray(response.topup)) throw new Error('Invalid response format: topup array not found')
  return response.topup.filter((pkg) => typeof pkg.byn1 === 'number' && Number.isFinite(pkg.byn1))
}

const createBynPayment = async (body) => {
  const amount = Object.values(body)[0]
  const validAmount = body.crystal !== undefined
    ? Number.isSafeInteger(amount) && amount > 0
    : Number.isFinite(amount) && amount > 0 && Math.round(amount * 10) / 10 === amount
  if (!validAmount) throw new Error('INVALID_AMOUNT')
  try {
    const response = await apiService.makeRequest('/api/byn1/', {
      method: 'POST',
      body: JSON.stringify(body)
    })
    if (response?.error) throw new Error(response.error)
    if (!response?.link) throw new Error('Invalid response format: link not found')
    return { link: response.link }
  } catch (error) {
    if (error.message === 'error sum') throw new Error('INVALID_AMOUNT')
    if (error.message === 'error limit') throw new Error('LIMIT_ORDER')
    if (error.message === 'error backend') throw new Error(error.status === 400 ? 'INVALID_REQUEST' : 'BACKEND_ERROR')
    throw error
  }
}

export const createPaymentByByn = (byn) => createBynPayment({ byn })
export const createPaymentByCrystals = (crystals) => createBynPayment({ crystal: crystals })
export const openBynPayment = (link, onRedirect, paymentWindow = null) => {
  openExternalPaymentLink(link, onRedirect, 'BYN', paymentWindow)
}

export default {
  fetchBynConfig,
  fetchBynPackages,
  createPaymentByByn,
  createPaymentByCrystals,
  openBynPayment
}
